import { DEFAULT_BUSINESS, type ChatMessage } from '@london-life/contracts';
import { useCatalogue } from '../lib/content';

// "🛍️ Visit my shop" in a chat (Lagos Life's shop card): whose shop, what it is and where, and for everyone else a
// button to open it (while it is open to players)
export function ShopCard({ message, onOpen }: { message: ChatMessage; onOpen?: (businessId: string) => void }) {
  const content = useCatalogue()?.business ?? DEFAULT_BUSINESS;
  const shop = message.shop!;
  const kind = content.kinds.find((item) => item.id === shop.kind);
  const area = content.areas.find((item) => item.id === shop.area)?.name ?? shop.area;
  return (
    <div className="money-card shop" data-status={shop.open ? 'open' : 'closed'}>
      <div className="money-card-top">
        <span className="money-card-icon" aria-hidden="true">
          {kind?.icon ?? '🛍️'}
        </span>
        <div>
          <small>{message.mine ? 'You shared your shop' : `${message.sender.firstName}’s shop`}</small>
          <strong className="gift-name">{shop.name}</strong>
        </div>
      </div>
      <p className="money-card-what">
        {kind?.label ?? shop.kind} · {area}
      </p>
      <p className="money-card-status">{shop.open ? '🟢 Open to players' : '⚪ Closed to players right now'}</p>
      {!message.mine && shop.open && onOpen && (
        <div className="money-card-actions">
          <button type="button" className="house-button save" onClick={() => onOpen(shop.businessId)}>
            🛍️ Open shop
          </button>
        </div>
      )}
    </div>
  );
}
